<template>
    <div class="advance-dropdowns">
        <div class="field is-horizontal" v-if="isMobile">
            <div class="field-label is-normal">
                <label class="label">Select Model</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select v-model="selectedModel" multiple>
                                <option v-for="model in getModels" :value="model.name">{{ model.name }}</option>
                            </select>
                            <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="auction-drop-box" v-if="!isMobile">
            <div class="car-select-tabs" :class="[(!isMobile ? 'hide' : '')]" @click="expandSelect">{{ model.length ?
                model.join(',') : 'Select MODEL' }}
            </div>
            <div class="car-select-box box"
                 :class="[(isMobile ? 'is-wider' : ''), (isMobile && !expand ? 'hide' : '')]">
                <table class="table" v-if="isBrandSelected">
                    <tr>
                        <td class="is-category">SELECT MODEL</td>
                    </tr>
                    <tr v-for="model in getModels">
                        <td :class="{ 'is-primary' : isSelected(model) }" @click="selectModel(model)"><span
                                v-html="model.name"></span></td>
                    </tr>
                </table>
                <p v-else="">Select Brand...</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            selectedModel: {
                get: function () {
                    return this.$store.getters.getQueryModelsStock;
                },
                set: function (model) {
                    this.$store.dispatch('removeModelsStock')
                    model.forEach(mod => {
                        this.$store.dispatch('addModelToQueryStock', mod)
                        this.$store.dispatch('fetchAllChassisByModelNameStock', mod)
                    });
                }
            },
            getModels() {
                //this.model = [];
                return this.$store.getters.getServerModelsStock
            },
            getSelectedBrand() {
                return this.$store.getters.getQueryCompanyIdStock
            },
            isBrandSelected() {
                return this.$store.getters.getServerModelsStock.length > 0
            },
            isMobile() {
                return document.documentElement.clientWidth < 450
            }
        },
        data() {
            return {
                expand: false,
                model: []
            }
        },
        methods: {
            isSelected(model) {
                return this.$store.getters.getQueryModelsByModelStock(model.name).length !== 0;
            },
            selectModel(model) {
                if (this.$store.getters.getQueryModelsByModelStock(model.name).length === 0) {
                    this.model.push(model.name);
                    this.$store.dispatch('addModelToQueryStock', model.name)
                    this.$store.dispatch('fetchAllChassisByModelNameStock', model.name)
                } else {
                    while (this.model.indexOf(model.name) !== -1) {
                        this.model.splice(this.model.indexOf(model.name), 1)
                    }
                    this.$store.dispatch('removeModelFromQueryStock', model.name)
                }
            },
            expandSelect() {
                console.log(this.model);
                this.expand = !this.expand;
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .box {
        height: 250px;
        width: 180px;
        overflow-y: auto;
    }

    .is-category {
        background-color: whitesmoke;
        font-weight: bold;
        color: #73aa00;
    }

    td {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        font-size: 14px !important;
        height: 15px !important;
        padding: 0px !important;
        font-weight: bold !important;
        max-width: 160px;
    }

    .is-wider {
        width: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/ModelStockCar.vue